<div class="layout">
  <!-- Tool bar -->
  <div class="layout__toolbar">
      <!-- Logo -->
      <img class="layout__toolbar--logo" src="./assets/glossary-management-logo.svg" alt="GlossaryManagementUI">
      <!-- tool bar buttons -->
      <div class="layout__toolbar--buttons" *ngIf="hasNavTools">
        <ng-container *ngFor="let n of navigationItems; index as i">
          <button 
            mat-flat-button 
            class="layout__toolbar--buttons__item"
            [ngClass]="{'layout__toolbar--buttons__item--selected': i === currentNavigationIndex}"
            (click)="navClick(n.link, i)"
          >
            <h2>{{ n.title }}</h2>
          </button>
        </ng-container> 
      </div>
      <!-- User Menu -->
      <mat-icon class="layout__toolbar--user-icon" [matMenuTriggerFor]="userMenu">person</mat-icon>
      <!-- User Menu -->
      <mat-menu #userMenu="matMenu">
        <ng-template matMenuContent>
          <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            <span  i18n="Logout label|Header label for Logout navigation link@@Logout">Logout</span>
          </button>
        </ng-template>
      </mat-menu>
  </div>
  <!-- Content -->
  <div class="layout__content">
    <router-outlet *ngIf="true"></router-outlet>
  </div>
  <!-- Footer -->
  <div class="layout__footer">
    <div class="layout__footer--agreements">
      <span (click)="termsOfServiceNavigation()">Terms of Service</span>
      |
      <span (click)="privacyPolicyNavigation()">Privacy Policy</span>
      |
      <span (click)="contactUsNavigation()">Contact us</span>
    </div>
    <span>Copyright © 2020 Health Standards Organization (HSO)</span>
  </div>
</div>
